<template>
    <el-button type="primary" size="mini" v-if="isShow" icon="el-icon-plus">{{ sLabel }}</el-button>
</template>

<script>
export default {
    name: "AddButton",
    data() {
        return {
            sLabel: '添加'
        }
    },
    props: {
        rule: '',
        label: {
            type: String,
            default: '添加'
        }
    },
    created() {
        this.sLabel = this.label;
    },
    watch: {
        label(n, o) {
            this.sLabel = n;
        }
    },
    computed: {
        isShow() {
            if(this.rule) {
                return this.$rule.checkRule(this.rule);
            }else{
                return true;
            }
        }
    }
}
</script>
